import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { PROJECT, TrackingEventName, UploadPhotoErrorTrackingEvent } from "./tracking";

interface TrackUploadPhotoErrorFunction {
  (): void;
}

interface UseTrackUploadPhotoErrorFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly customerId: string;
  readonly tradename: Tradename;
}

interface UseTrackUploadPhotoErrorFunction {
  (agrs: UseTrackUploadPhotoErrorFunctionArgs): TrackUploadPhotoErrorFunction;
}

const useTrackUploadPhotoError: UseTrackUploadPhotoErrorFunction = ({ country, segment, customerId, tradename }) => {
  const emitUserEvent = useEmitUserEvent<UploadPhotoErrorTrackingEvent>();

  const trackUploadPhotoError: TrackUploadPhotoErrorFunction = useCallback(() => {
    emitUserEvent({
      event: TrackingEventName.UPLOAD_PHOTO_ERROR,
      eventCategory: TrackingEventCategory.NAVIGATION,
      section: `${PROJECT}_photos`,
      store: country,
      segment,
      userId: customerId,
      tradename,
    });
  }, [country, emitUserEvent, customerId, tradename, segment]);

  return trackUploadPhotoError;
};

export { useTrackUploadPhotoError };
